import React from "react"

export default function Title() {
    return (
        <h1>MARY CALLANAN</h1>

    )
}